import withDebugId from './withDebugId';

var createTheme = function createTheme(themeInput, debugId) {
  return withDebugId(themeInput, debugId);
};

export default createTheme;